import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'murder-hornet-ui';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, Outlet, useNavigate } from 'react-router-dom';

import TOSModal from '../../components/auth/TOSModal';
import NavBar from '../../components/navigation/NavBar';
import SideNav from '../../components/navigation/SideNav';
import { resetUI } from '../../redux/reducers/modals';


const AppWrapper = ({ sideNavOpen, toggleSideNav }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const refresh_tos = useSelector((state) => state.auth.currentUser.refresh_tos);
  const forbidden = useSelector((state) => state.ui.forbidden);


  return (
    <>
      <div className='d-flex flex-row'>
        <SideNav isOpen={sideNavOpen} toggle={toggleSideNav} />

        <div className={`app-wrapper ${sideNavOpen ? 'sidenav-active' : ''}`}>
          <NavBar sideNavOpen={sideNavOpen} toggleSideNav={toggleSideNav} />
          <div className='content-wrapper bg-light'>
            <div className={`content-wrapper-inner position-relative bg-white ${location?.pathname?.includes('dashboard') ? '' : 'p-4 p-sm-5'}`}>
              <Outlet context={{ sideNavOpen, toggleSideNav }} />
            </div>
          </div>
        </div>
      </div>

      {/* Force accept TOS if refresh_tos is true */}
      {isLoggedIn && refresh_tos && <TOSModal />}

      {forbidden && (
        <Modal
          isOpen={forbidden}
          onHide={() => {
            navigate('/applications');
            dispatch(resetUI());
          }}
          variant='success'
          title={'You Don\'t Have Permission To Access This File'}
          ctaButton
          ctaText='Back to Pipeline'
          ctaFunction={() => {
            navigate('/applications');
            dispatch(resetUI());
          }}
        >
          <div>
            To view this file, you&apos;ll need to be added as a follower. (Anyone with access to this file can do this.)
          </div>
        </Modal>
      )}
    </>
  );
};

AppWrapper.propTypes = {
  sideNavOpen: PropTypes.bool,
  toggleSideNav: PropTypes.func,
};

export default AppWrapper;
